<template>
  <div class="home">
    <a-row :gutter="[16,16]">
      <a-col span="24">
        <div class="iotplt-card-box">
          <finance-statistics />
        </div>
      </a-col>

      <!--      <a-col span="12">-->
      <!--        <div class="iotplt-card-box">-->
      <!--          <recent-notifications />-->
      <!--        </div>-->
      <!--      </a-col>-->
    </a-row>

    <a-row :gutter="[16,16]">
      <a-col span="24">
        <div class="iotplt-card-box">
          <cards-count-statistics />
        </div>
      </a-col>
    </a-row>

    <a-row :gutter="[16,16]">
      <a-col span="12">
        <div class="iotplt-card-box">
          <current-month-operational-cards-statistics />
        </div>
      </a-col>

      <a-col span="12">
        <div class="iotplt-card-box">
          <flow-usage-statistics />
        </div>
      </a-col>
    </a-row>

    <contract-alert-modal
      v-if="isShowContractAlertModal"
      :key="contractAlertModalKey"
      :visible.sync="isShowContractAlertModal"
      :alert-info="contractAlertInfo"
    />
  </div>
</template>

<script>
import FinanceStatistics from '@/views/home/FinanceStatistics'
import CardsCountStatistics from '@/views/home/CardsCountStatistics'
import CurrentMonthOperationalCardsStatistics from '@/views/home/CurrentMonthOperationalCardsStatistics'
import FlowUsageStatistics from '@/views/home/FlowUsageStatistics'
// import RecentNotifications from '@/views/home/RecentNotifications'
import { findHomeAgentName, findAgentContractAlert } from '@/api/agent'
import { getOriginalUserUid } from '@/utils/token'
export default {
  name: 'Home',
  components: {
    // RecentNotifications,
    FlowUsageStatistics,
    CurrentMonthOperationalCardsStatistics,
    CardsCountStatistics,
    FinanceStatistics,
    ContractAlertModal: () => import('@/views/home/ContractAlertModal')
  },
  data() {
    return {
      isShowContractAlertModal: false,
      contractAlertInfo: {},
      contractAlertModalKey: 0
    }
  },
  computed: {
    agentId() {
      return this.$store.getters.userAgentId
    }
  },
  created() {
    this.setBreadcrumb()
    this.checkContractAlert()
  },
  methods: {
    checkContractAlert() {
      const originalUserUid = getOriginalUserUid()
      if (!originalUserUid || !this.agentId || this.$store.getters.userRole !== 'top_agent') {
        return
      }

      findAgentContractAlert(this.agentId, {
        original_user_uid: originalUserUid
      }).then((res) => {
        if (res.code === 0 && res.data && res.data.show_alert) {
          this.contractAlertInfo = res.data
          this.contractAlertModalKey += 1
          this.$nextTick(() => {
            this.isShowContractAlertModal = true
          })
        }
      })
    },
    setBreadcrumb() {
      findHomeAgentName(this.agentId).then((res) => {
        if (res.code === 0) {
          this.$store.dispatch('SetDynamicBreadCrumbsPlaceholder', { ':agent_name': '欢迎您，' + res.data.name })
        }
      })
    }
  }
}
</script>
